import { useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import Loader from "../../../Loader";
import EquifaxForm from "./EquifaxForm";

export default function EquifaxCreditReportDashboard() {
      const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading="Equifax Credit Report Dashboard" />

      <div className="bg-gray-100 min-h-screen">
        <div className="max-w-7xl mx-auto space-y-6">

          <EquifaxForm
           />
        </div>
      </div>
    </>
  );
}
